import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CouponUsageType } from '../../models/coupon';
import { MultiselectItem } from '../../../core/interfaces/admin.interface';
import { TranslateService } from '@ngx-translate/core';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';

@Component({
  selector: 'sacbo-coupon-usage-type-select',
  templateUrl: './coupon-usage-type-select.component.html',
  styleUrls: ['./coupon-usage-type-select.component.scss']
})
export class CouponUsageTypeSelectComponent {

  @Input() typeSelected: MultiselectItem[] = [];

  @Output() typeSelectedChange = new EventEmitter< MultiselectItem[]>();
  @Output() onSelected = new EventEmitter< MultiselectItem[]>();

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  typeList: MultiselectItem[] = [];

  constructor(
    private translate: TranslateService,
  ) {

    this.typeList = [
      { id: CouponUsageType.ALL, itemName: this.translate.instant('multiselect.usageType.' + CouponUsageType.ALL) },
      { id: CouponUsageType.CUSTOMER, itemName: this.translate.instant('multiselect.usageType.' + CouponUsageType.CUSTOMER) }/*,
      { id: CouponUsageType.USER, itemName: CouponUsageType.USER }*/
    ]

  }

  onTypeSelect(): void {
    this.typeSelectedChange.emit(this.typeSelected);
    this.onSelected.emit(this.typeSelected);
  }

}
